export default __webpack_public_path__ + "static/media/1852.75b81b82.png";